module.exports = __webpack_public_path__ + "img/502.4707120d.jpg";